interface TallyProps {
  on?: boolean;
  size?: number;
}

export function Tally({ on = true, size = 6 }: TallyProps) {
  return (
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "var(--tls-radius-pill)",
        background: on ? "var(--tls-brand)" : "var(--tls-fg-faint)",
      }}
    />
  );
}
